(function () {
  var RATES = { AED: 1, EUR: 0.25, USD: 0.2723 };
  var SYMBOLS = { AED: 'Dhs.', EUR: '€', USD: '$' };
  var STORAGE_KEY = 'noyau_display_currency';
  var DEFAULT_CURRENCY = 'EUR';

  function getCurrency() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_CURRENCY;
    } catch (e) {
      return DEFAULT_CURRENCY;
    }
  }

  function format(amount, code) {
    var symbol = SYMBOLS[code] || code;
    var value = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return code === 'AED' ? symbol + ' ' + value : symbol + value;
  }

  // Matches Shopify's native `money` filter output for this shop, e.g. "Dhs. 187.00" or "Dhs. 1,187.00".
  var AED_TEXT_RE = /Dhs\.?\s*([\d,]+(?:\.\d+)?)/;

  function convertAll() {
    var code = getCurrency();
    var rate = RATES[code] || RATES[DEFAULT_CURRENCY];

    // Our own hand-built sections: raw AED cents already sit in a data attribute.
    document.querySelectorAll('[data-aed-cents]').forEach(function (node) {
      var cents = parseFloat(node.getAttribute('data-aed-cents'));
      if (isNaN(cents)) return;
      var amount = (cents / 100) * rate;
      node.textContent = format(amount, code);
    });

    // Native Shopify price blocks (PDP price, cart, "you may also like", collection cards) --
    // these always render in AED (the shop's real currency) via Liquid's `money` filter, with no
    // raw-cents attribute available client-side. Parse the AED figure once, cache it, and always
    // reconvert from that cached figure so repeated passes stay stable and don't compound.
    var nativeSelector = '.price, .price-item__group, .compare-at-price, .unit-price';
    document.querySelectorAll(nativeSelector).forEach(function (node) {
      if (node.hasAttribute('data-aed-cents')) return;
      if (node.children.length > 0) return; // only leaf text nodes

      var current = node.textContent.trim();
      var lastOutput = node.getAttribute('data-noyau-last-output');

      // If the text matches what we last wrote out, nothing has changed -- skip re-parsing it.
      if (lastOutput !== null && current === lastOutput) return;

      var match = current.match(AED_TEXT_RE);
      if (!match) return;

      var aedAmount = parseFloat(match[1].replace(/,/g, ''));
      if (isNaN(aedAmount)) return;

      node.setAttribute('data-noyau-aed-amount', aedAmount);
      var amount = aedAmount * rate;
      var newText = format(amount, code);
      node.textContent = newText;
      node.setAttribute('data-noyau-last-output', newText);
    });

    document.querySelectorAll('[data-noyau-currency-select]').forEach(function (el) {
      el.value = code;
    });
  }

  window.NoyauCurrency = {
    RATES: RATES,
    DEFAULT_CURRENCY: DEFAULT_CURRENCY,
    get: getCurrency,
    set: function (code) {
      try {
        window.localStorage.setItem(STORAGE_KEY, code);
      } catch (e) {}
      convertAll();
    },
  };

  document.addEventListener('DOMContentLoaded', convertAll);
  document.addEventListener('shopify:section:load', convertAll);

  document.addEventListener('DOMContentLoaded', function () {
    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(convertAll, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
